'use client';

import { c as _c } from "react/compiler-runtime";
import type { JSX } from 'react';
import { useEffect, useRef } from 'react';
import { onEvent } from '@/events';
import { NudgeLoading } from './nudge-loading';
import { NudgeMatches } from './nudge-matches';
import { NudgeUnique } from './nudge-unique';
import { useSimilarDebounce } from './use-similar-debounce';
const DEFAULT_THRESHOLD = 0.65;
export interface SimilarMarketsNudgeProps {
  readonly queryText: string;
  readonly threshold?: number;
}
export function SimilarMarketsNudge(t0) {
  const $ = _c(16);
  const {
    queryText,
    threshold: t1
  } = t0;
  const threshold = t1 === undefined ? DEFAULT_THRESHOLD : t1;
  const {
    status,
    matches,
    dismiss
  } = useSimilarDebounce(queryText, threshold);
  const lastShownStatus = useRef(null);
  let t2;
  if ($[0] !== matches) {
    t2 = matches.reduce(_temp, 0);
    $[0] = matches;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const topSimilarity = t2;
  let t3;
  let t4;
  if ($[2] !== matches.length || $[3] !== queryText.length || $[4] !== status || $[5] !== topSimilarity) {
    t3 = () => {
      if (status === "matches" && lastShownStatus.current !== "matches") {
        lastShownStatus.current = "matches";
        onEvent("duplicate_nudge_shown", {
          matchCount: matches.length,
          topSimilarity
        });
      } else {
        if (status === "empty" && lastShownStatus.current !== "empty") {
          lastShownStatus.current = "empty";
          onEvent("unique_market_affirmation_shown", {
            queryLength: queryText.length
          });
        } else {
          if (status === "idle" || status === "loading" || status === "error") {
            lastShownStatus.current = null;
          }
        }
      }
    };
    t4 = [status, matches.length, queryText.length, topSimilarity];
    $[2] = matches.length;
    $[3] = queryText.length;
    $[4] = status;
    $[5] = topSimilarity;
    $[6] = t3;
    $[7] = t4;
  } else {
    t3 = $[6];
    t4 = $[7];
  }
  useEffect(t3, t4);
  let t5;
  if ($[8] !== dismiss || $[9] !== matches.length) {
    t5 = () => {
      onEvent("duplicate_nudge_dismissed", {
        matchCount: matches.length
      });
      dismiss();
    };
    $[8] = dismiss;
    $[9] = matches.length;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const handleDismiss = t5;
  if (status === "idle" || status === "error") {
    return null;
  }
  if (status === "loading") {
    let t6;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <NudgeLoading />;
      $[11] = t6;
    } else {
      t6 = $[11];
    }
    return t6;
  }
  if (status === "empty") {
    let t6;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <NudgeUnique />;
      $[12] = t6;
    } else {
      t6 = $[12];
    }
    return t6;
  }
  let t6;
  if ($[13] !== handleDismiss || $[14] !== matches) {
    t6 = <NudgeMatches matches={matches} onDismiss={handleDismiss} />;
    $[13] = handleDismiss;
    $[14] = matches;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
}
function _temp(max, m) {
  return m.similarity > max ? m.similarity : max;
}